// Common translations - English
export const commonEn = {
  // General actions
  actions: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    close: 'Close',
    next: 'Next',
    previous: 'Previous',
    search: 'Search',
    filter: 'Filter',
    clear: 'Clear',
    apply: 'Apply',
    contact: 'Contact',
    send: 'Send',
    share: 'Share',
  },

  // States
  states: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    empty: 'Empty',
    notFound: 'Not found',
  },

  // Forms
  forms: {
    required: 'This field is required',
    invalidEmail: 'Invalid email address',
    invalidPhone: 'Invalid phone number',
    minLength: 'Minimum {min} characters',
    maxLength: 'Maximum {max} characters',
  },

  // Currency and formats
  currency: {
    clp: 'CLP',
    usd: 'USD',
    eur: 'EUR',
  },

  // Units
  units: {
    km: 'km',
    miles: 'miles',
    year: 'year',
    years: 'years',
  },
};


